import { render, staticRenderFns } from "./bclose-popup.vue?vue&type=template&id=2ed9742e&scoped=true&"
import script from "./bclose-popup.vue?vue&type=script&lang=js&"
export * from "./bclose-popup.vue?vue&type=script&lang=js&"
import style0 from "./bclose-popup.vue?vue&type=style&index=0&id=2ed9742e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9742e",
  null
  
)

export default component.exports